import getChecked from 'services/forms/getChecked';
import getTargetName from 'services/forms/getTargetName';
import getTargetValue from 'services/forms/getTargetValue';
import replaceCommas from 'services/numbers/replaceCommas';

export const CHECKBOX_FIELD_EVENT = 'checkbox';
export const TEXT_FIELD_EVENT = 'text';
export const CREATABLE_DROPDOWN_EVENT = 'creatable';

const editFieldEventHandler =
  (
    originalObject: any,
    setter: any,
    type = TEXT_FIELD_EVENT,
    targetName?: string
  ) =>
  (e: any): void => {
    let name = '';
    if (typeof targetName !== 'undefined') {
      name = targetName;
    } else {
      name = getTargetName(e);
    }

    if (type === CHECKBOX_FIELD_EVENT) {
      setter({
        ...originalObject,
        [name]: getChecked(e),
      });

      return;
    }

    if (type === CREATABLE_DROPDOWN_EVENT) {
      setter({
        ...originalObject,
        [name]: replaceCommas(e.value),
      });

      return;
    }

    setter({
      ...originalObject,
      [name]: getTargetValue(e),
    });
  };

export default editFieldEventHandler;
